<template lang="pug">
div
  table(:class="layout === 'linear' ? 'qr-print-wrapper' : ''")
    tbody(v-if="layout === 'grid'")
      tr(
        v-for="(chunkedItems, index) in items",
        :style="trStyle(index)",
        :key="`chunked-list-${chunkedItemsKey(chunkedItems)}`"
      )
        th(v-if="chunkedItems[0]") 
          qr(:title="getTitle(chunkedItems[0])", :texts="getTexts(chunkedItems[0])", :url="chunkedItems[0].url")
        th(v-if="chunkedItems[1]")
          qr(:title="getTitle(chunkedItems[1])", :texts="getTexts(chunkedItems[1])", :url="chunkedItems[1].url")

    tbody(v-else-if="layout === 'linear'")
      tr(v-for="item in list")
        th
          qr(
            :title="getTitle(item)",
            :texts="getTexts(item)",
            :url="item.url",
            :layout="layout",
            :paperWidth="paperWidth",
            :paperHeight="paperHeight"
          )
</template>

<script setup>
import { computed, onMounted } from "vue";
import qr from "./qr";
import _ from "lodash";

const emit = defineEmits(["mounted"]);

const props = defineProps({
  /** Данные о всех qr кодах которые нужно вывести. Пример: 
{
  [
    {
      "url": "https://localhost:3000/mobile_qr?type=ppr_equipment\u0026id=35",
      "form": {
        "header": "ООО \"МВМ\"/Оборудование 35",
        "fields": [
            {
              "label": "ВСП 32//",
              "value": ""
            },
            {
              "label": "Наименование:",
              "value": "Тест 1"
            },
            {
              "label": "Система:",
              "value": "ТО ИС"
            }
        ]
      }
    },
  ]
   */
  list: { type: Array, default: () => [], required: true },
  /** Флаг отображения qr кодов в одну колонку или в две. Пример: "linear/grid" */
  layout: { type: String, default: () => "grid" },
  paperWidth: { type: Number || String, default: () => 0 },
  paperHeight: { type: Number || String, default: () => 0 },
});

const items = computed(() => _.chunk(props.list, 2));

const trStyle = index => {
  const trueIndex = index + 1;

  return trueIndex % 3 == 0 ? { "page-break-after": "always" } : {};
};

const chunkedItemsKey = items => {
  const ids = items.map(item => item.id);
  const key = ids.join("-");

  return key;
};

const getTitle = item => {
  return item.form.header;
};

const getTexts = item => {
  return item.form.fields;
};

onMounted(() => {
  emit("mounted");
});
</script>

<style lang="scss">
@import "../../../assets/styles/printQr/qr.scss"; // This style has separate import and injected in new tab
</style>
